/** Shared shape for Add / Edit employee forms */
export interface EmployeeFormState {
  firstName: string;
  imageUrl: string;
  lastName: string;
  title: string;
  email: string;
  password: string;
  confirmpassword: string;
  roleId: string;
  phoneNumber: string;
  address: string;
  employeeId: string;
  color: string;
  IsDentist: boolean;
  IsBookDentist: boolean;
  image?: File | string | null;
  studies?: string[];
  specialities?: string[];
  languages: string[];
}

export const colorOptions = [
  { color: "rgba(102, 178, 255, 0.7)", name: "Sky Blue" },
  { color: "rgba(255, 204, 153, 0.7)", name: "Peach" },
  { color: "rgba(153, 204, 255, 0.7)", name: "Pale Blue" },
  { color: "rgba(178, 255, 102, 0.7)", name: "Lime" },
  { color: "rgba(255, 153, 204, 0.7)", name: "Pink" },
  { color: "rgba(204, 255, 204, 0.7)", name: "Mint" },
  { color: "rgba(255, 229, 204, 0.7)", name: "Cream" },
  { color: "rgba(204, 229, 255, 0.7)", name: "Light Sky" },
  { color: "rgba(255, 255, 153, 0.7)", name: "Yellow" },
  { color: "rgba(229, 204, 255, 0.7)", name: "Lavender" },
] as const;

export const languageOptions = ["English", "Sinhala", "Tamil"] as const;
